var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fts-release-badge",class:{ 'release-badge--primary': _vm.newRelease || _vm.upcoming }},[_vm._v("\n  "+_vm._s(_vm.getBadgeLabel)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }